module.exports = __webpack_public_path__ + "static/media/3_in1_classic_prikaz.c6b4fb3b.jpg";